module.exports = __webpack_public_path__ + "36c3ed8b000e7423316a8f199800d9ad.pdf";